import {Component, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChange, ViewChild} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Message} from "../../../../../../models/message";
import {MessageReceiver} from "../../../../../../models/message_receiver";
import {Role} from "../../../../../../models/role";
import {RoleStatusMessage} from "../../../../../../models/status-message";
import {RoleStatusService} from "../../../../../../services/role-controller/role-status.service";
import {Store} from "../../../../../../services/store.service";
import {BaseError} from "../../../../base-error";
import {AuthService} from "../../../../../../services/auth/auth-service";

@Component({
  selector: "status-message-edit",
  templateUrl: "./status-message-edit.component.html",
  styles: [],
  providers: [ToastrService],
})
export class StatusMessageEditComponent extends BaseError implements OnInit {

  @Input() public message: Message;
  @Input() public allRoles: Role[];
  @Input() public role: Role;
  @Input() public roleStatusMessage: RoleStatusMessage;
  @Input() public messageType: string;
  @Input() public statusType: string;
  @Output() public editCancel = new EventEmitter();
  @Output() public editSave = new EventEmitter();
  @ViewChild("trans_applicant") public applicant_translation: ElementRef;

  public roles: any[];
  public selectedRoles: any[] = [];
  public editOrNew: string;
  public valueDays: number = 0;
  public valueHours: number = 0;
  public triggerDropDownRoles: boolean = false;
  public rolesReady: boolean = false;

  constructor(toastr: ToastrService, private authService: AuthService,
              private roleStatusService: RoleStatusService, public store: Store) {
    super(toastr);
  }

  public ngOnInit() {
    // console.log("--- Status message dit INIT", this.message, this.allRoles, this.messageType, this.roleStatusMessage);
    this.pushToRolesDropDownValues();
  }

  public async ngAfterViewInit() {
    if (this.triggerDropDownRoles) { return await this.pushToRolesDropDownValues(); }
  }

  public async ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    // console.log("--- async ngOnChanges", changes);
    if (changes.editOrNew && changes.editOrNew.currentValue) {
      this.editOrNew = changes.editOrNew.currentValue;
    }
    if (changes.roleStatusMessage && changes.roleStatusMessage.currentValue && !changes.roleStatusMessage.firstChange) {
      this.roleStatusMessage = changes.roleStatusMessage.currentValue;
      this.triggerDropDownRoles = true;
    }
    if (changes.message && changes.message.currentValue) {
      this.message = changes.message.currentValue;
      if (!this.roleStatusMessage || this.editOrNew === "new") {
        this.roleStatusMessage = new RoleStatusMessage();
      }
      this.roleStatusMessage.message = this.message;
    }
    if (changes.allRoles && changes.allRoles.currentValue && !changes.allRoles.firstChange) {
      this.allRoles = changes.allRoles.currentValue;
      this.triggerDropDownRoles = true;
    }
  }

  public async pushToRolesDropDownValues() {
    this.rolesReady = false;
    this.selectedRoles = [];
    this.roles = [];

    if (this.messageType === "MESSAGE") {
      if (this.allRoles) {
        this.allRoles.forEach((role) => {
          if (role.type === "UserRole") {
            this.roles.push({id: role.id, text: this.getTranslation(role.name)});
          }
        });
      }
      const email = await this.authService.getUserEmail();
      this.roles.push({id: email, text: email});
      this.roles.push({id: "applicant-email", text: "tag: 'applicant-email'"});
      // console.log(this.roleStatusMessage, this.roles);
      if (this.roleStatusMessage && this.roleStatusMessage.receivers) {
        this.roleStatusMessage.receivers.forEach((item) => {
          const role = this.roles.find((it) => it.id === item.receiver);
          if (!role) {
            this.roles.push({id: item.receiver, text: item.receiver});
          }
          this.selectedRoles.push(item.receiver);
        });
      }
    } else if (this.messageType === "ALERT") {
      if (this.allRoles) {
        const role = this.allRoles.find((it) => it.name === "Applicant");
        if (role) {
          this.roles.push({id: role.id, text: this.getTranslation(role.name)});
        }
      }
      this.roles.push({id: "applicant-email", text: "tag: 'applicant-email'"});
      if (this.roleStatusMessage && this.roleStatusMessage.receivers && this.roleStatusMessage.receivers.length > 0) {
        this.roleStatusMessage.receivers.forEach((item) => {
          const role = this.roles.find((it) => it.id === item.receiver);
          if (role) {
            this.selectedRoles.push(item.receiver);
          }
        });
      } else if (this.roles && this.roles.length > 0) {
        this.selectedRoles.push(this.roles[0].id);
      }
    }
    // this.roles = roles;
    // this.selectedRoles = this.selectedRoles;
    // console.log("--- roles in status edit", this.roles, this.selectedRoles);
    this.rolesReady = true;
  }

  public addReceivers() {
      if (this.selectedRoles) {
          this.roleStatusMessage.receivers = [];
          this.selectedRoles.forEach((item) => {
              const rec = new MessageReceiver();
              rec.receiver = item;
              this.roleStatusMessage.receivers.push(rec);
          });
      }
  }

  public getDisplayDelay(delay) {
    return `${delay.substring(delay.indexOf("P") + 1, delay.indexOf("D"))} days - ${delay.substring(delay.indexOf("T") + 1, delay.indexOf("H"))} hours`;
  }

  public addNewDelay() {
    const newDelay = {
      id: null,
      value: `P${this.valueDays}DT${this.valueHours}H`,
    };
    this.roleStatusMessage.delays.push(newDelay);
    this.resetInputs();
  }

  public resetInputs() {
    this.valueDays = 0;
    this.valueHours = 0;
  }

  public removeDelay(isConfirmed, index) {
    if (isConfirmed) {
      this.roleStatusMessage.delays.splice(index, 1);
    }
  }

  public submit() {
    if (this.valueDays > 0 || this.valueHours > 0) { this.addNewDelay(); }
    this.addReceivers();
    this.roleStatusService.roleStatusMessage = this.roleStatusMessage;
    this.roleStatusService.statusType = this.statusType;
    this.roleStatusService.updateData();
    this.editSave.emit({statusMessage: this.roleStatusMessage});
    this.closeLayer();
  }

  public closeLayer() {
    this.editCancel.emit({cancel: true});
  }

  public getTranslation(name: string) {
    if (name === "Applicant") {
      return this.applicant_translation !== undefined ? this.applicant_translation.nativeElement.textContent.trim().toString() : name;
    } else {
      return name;
    }
  }

}
